import { Bound } from "lib/@components/binding/Bound"
import { TwoSchedules } from "routes/schedule/compare/twoSchedules"
import { ScheduleIntroduction } from "routes/schedule/scheduleIntroduction"
import { Repeat } from "lib/@components/repeat"
import { CompareTasks } from "routes/schedule/compare/compareTasks"
import { MissingTask } from "routes/schedule/compare/missingTask"
import { Box, Typography } from "@mui/material"
import { ComparisonUpdated } from "event-definitions"
import { ScheduleTitle } from "routes/schedule/scheduleTitle"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { findTask } from "routes/schedule/compare/find-task"
import { useState } from "react"
import { htmlToText } from "lib/html-to-text"
import { cleanHTMLForComparison } from "routes/schedule/compare/ifNotSameText"
import { InlineCompareButtons } from "./inline-approval-buttons/inline-compare-buttons"
import { CompareButtonsBelow } from "slot-definitions"
import { ScheduleReviewJustification } from "./schedule-review-justification"

export function compareTwoStringsForMeaning(v1, v2) {
    return (
        htmlToText(v1).trim().toLowerCase().replace(/\W+/g, "~") ===
        htmlToText(v2).trim().toLowerCase().replace(/\W+/g, "~")
    )
}

export function BothPanel() {
    CompareButtonsBelow.usePlug(<ScheduleReviewJustification />)

    const { target, comparisonTarget, comparisons, compare } = useBoundContext()
    const [canCopyTitle] = useState(target.title !== comparisonTarget.title)
    const [canCopyIntro] = useState(compareIntro)
    const movements = comparisons?.find((item) => item?.props?.children?.props?.componentType === "Movements") ?? null
    const guidance =
        comparisons?.filter((item) =>
            ["NewGuidance", "RemovedGuidance"].includes(item?.props?.children?.props?.componentType)
        ) ?? []
    const groupReviewId = target?.groupReviewId

    return (
        <Bound editInDialog={true} acceptId="movements" groupReviewId={groupReviewId}>
            <Bound showEditor={true} acceptId="details" hideUpBar={true} hideToolbar={true}>
                <TwoSchedules
                    leftSchedule={target}
                    rightSchedule={comparisonTarget}
                    copied={target.title === comparisonTarget.title}
                    showCopy={canCopyTitle}
                    copy={copyDetails}
                    revert={revertDetails}
                    left={<ScheduleTitle schedule={target} />}
                    right={
                        <Bound target={comparisonTarget} schedule={comparisonTarget}>
                            <ScheduleTitle schedule={comparisonTarget} />
                        </Bound>
                    }
                    after={<InlineCompareButtons idFromGroup={"details"} to={target} from={comparisonTarget} />}
                />
            </Bound>
            <Bound acceptId="intro">
                <TwoSchedules
                    leftSchedule={target}
                    rightSchedule={comparisonTarget}
                    copied={!compareIntro()}
                    copy={copyIntro}
                    revert={revertIntro}
                    showCopy={canCopyIntro}
                    left={<ScheduleIntroduction schedule={target} />}
                    right={
                        <Bound originalTarget={target} target={comparisonTarget} schedule={comparisonTarget}>
                            <ScheduleIntroduction schedule={comparisonTarget} />
                        </Bound>
                    }
                    after={<InlineCompareButtons idFromGroup={"intro"} to={target} from={comparisonTarget} />}
                />
            </Bound>
            <Repeat list={compare.tasks} pass="task" item={<CompareTasks />} />
            <Repeat
                list={comparisonTarget.tasks.filter((t) => !findTask(compare.tasks, t))}
                pass="task"
                item={<MissingTask />}
            />
            {movements}
            {!!movements && <InlineCompareButtons idFromGroup={"movements"} to={target} from={comparisonTarget} />}
            {!!guidance?.length && (
                <Typography sx={{ pl: 5, mt: 2 }} component="div" variant="subtitle1">
                    References
                </Typography>
            )}
            {guidance.map((g, i) => ({ ...g, key: i }))}
            {!!guidance?.length && (
                <InlineCompareButtons idFromGroup={"Guidance"} to={target} from={comparisonTarget} />
            )}
            <Box mb={60} />
        </Bound>
    )

    function copyIntro() {
        target.intro.content = comparisonTarget.intro.content
        target.intro.note = comparisonTarget.intro.note
        ComparisonUpdated.raiseOnce()
    }

    function revertIntro() {
        target.intro.content = compare.intro.content
        target.intro.note = compare.intro.note
        ComparisonUpdated.raiseOnce()
    }

    function copyDetails() {
        target.title = comparisonTarget.title
        // target.code = comparisonTarget.code
        ComparisonUpdated.raiseOnce()
    }

    function revertDetails() {
        target.title = compare.title
        // target.code = compare.code
        ComparisonUpdated.raiseOnce()
    }

    function compareIntro() {
        return (
            cleanHTMLForComparison(compare.intro.content) !== cleanHTMLForComparison(comparisonTarget.intro.content) ||
            cleanHTMLForComparison(compare.intro.notes) !== cleanHTMLForComparison(comparisonTarget.intro.notes)
        )
    }
}
